// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateGLAccountMappingMutation(
    $input: UpdateGLAccountMappingInput!
  ) {
    updateGLAccountMapping(input: $input) {
      glAccountMapping {
        id
        mappingKey
        account {
          id
          accountNumber
          name
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, { ...options });
  },
};
